import Vue from 'vue'
import Vessel from 'vessel'

export default ({ app }, inject) => {
  const i18n = (key, value) => app.i18n.t(key, value)
  Vue.use(Vessel, { i18n })

  inject('screen', Vue.prototype.$screen)
}
